import 'instrument';

import { ThemeProvider } from '@conteg/ui';
import * as Sentry from '@sentry/react';
import App from 'app';
import ErrorFallback from 'components/error-fallback/error-fallback';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'utils/auth/auth';
import { GqlSubscriptionProvider } from 'utils/gql/gql-subscriptions';
import QueryClientProvider from 'utils/gql/query-client-provider';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ThemeProvider>
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <AuthProvider>
        <QueryClientProvider>
          <GqlSubscriptionProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </GqlSubscriptionProvider>
        </QueryClientProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </ThemeProvider>
);
